import { render, staticRenderFns } from "./ListEmployeeResignation.vue?vue&type=template&id=16c503a6&scoped=true&"
import script from "./ListEmployeeResignation.vue?vue&type=script&lang=js&"
export * from "./ListEmployeeResignation.vue?vue&type=script&lang=js&"
import style0 from "./ListEmployeeResignation.vue?vue&type=style&index=0&id=16c503a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c503a6",
  null
  
)

export default component.exports